import auth from "@/helper/middleware/auth";
export default [
  {
    path: "/notification",
    name: "notification",
    component: () => import("@/views/notification/NotificationView.vue"),
    meta: { middleware: [auth] },
  },
];
